import * as Types from "../../../graphql/globalTypes.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type StudentNavigationQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type StudentNavigationQuery = {
  studentViewer: {
    id: string;
    activeReflectionQuestions: {
      nodes: Array<{
        id: string;
        hasNotifications: boolean;
        hidden: boolean;
        isExpired: boolean;
        reportedByViewer: boolean;
        studentReadAt?: string | null;
        messages: Array<{
          id: string;
          content?: string | null;
          multipleChoiceOptionText?: string | null;
          stickers: Array<Types.Sticker>;
          createdAt: string;
          author:
            | {
                __typename: "Student";
                id: string;
                name: string;
                profileImage?: { id: string; url: string } | null;
              }
            | {
                __typename: "Teacher";
                id: string;
                name: string;
                profileImage?: { id: string; url: string } | null;
              };
          media?:
            | { __typename: "AudioRecording"; id: string }
            | { __typename: "Video"; id: string }
            | null;
        }>;
        session: {
          id: string;
          description?: string | null;
          hidden: boolean;
          prompt: string;
          publishedAt: string;
          media?:
            | { __typename: "AudioRecording" }
            | { __typename: "Video" }
            | null;
          teacher: {
            id: string;
            name: string;
            profileImage?: { id: string; url: string } | null;
          };
        };
      }>;
    };
    completedReflectionQuestions: {
      nodes: Array<{
        id: string;
        hasNotifications: boolean;
        hidden: boolean;
        isExpired: boolean;
        reportedByViewer: boolean;
        studentReadAt?: string | null;
        messages: Array<{
          id: string;
          content?: string | null;
          multipleChoiceOptionText?: string | null;
          stickers: Array<Types.Sticker>;
          createdAt: string;
          author:
            | {
                __typename: "Student";
                id: string;
                name: string;
                profileImage?: { id: string; url: string } | null;
              }
            | {
                __typename: "Teacher";
                id: string;
                name: string;
                profileImage?: { id: string; url: string } | null;
              };
          media?:
            | { __typename: "AudioRecording"; id: string }
            | { __typename: "Video"; id: string }
            | null;
        }>;
        session: {
          id: string;
          description?: string | null;
          hidden: boolean;
          prompt: string;
          publishedAt: string;
          media?:
            | { __typename: "AudioRecording" }
            | { __typename: "Video" }
            | null;
          teacher: {
            id: string;
            name: string;
            profileImage?: { id: string; url: string } | null;
          };
        };
      }>;
    };
    notifications: Array<{ id: string }>;
    statsForStudent: {
      allSessionsReceived: number;
      allSessionsResponded: number;
    };
  };
};

export type StudentNavReflectionFragment = {
  id: string;
  hasNotifications: boolean;
  hidden: boolean;
  isExpired: boolean;
  reportedByViewer: boolean;
  studentReadAt?: string | null;
  messages: Array<{
    id: string;
    content?: string | null;
    multipleChoiceOptionText?: string | null;
    stickers: Array<Types.Sticker>;
    createdAt: string;
    author:
      | {
          __typename: "Student";
          id: string;
          name: string;
          profileImage?: { id: string; url: string } | null;
        }
      | {
          __typename: "Teacher";
          id: string;
          name: string;
          profileImage?: { id: string; url: string } | null;
        };
    media?:
      | { __typename: "AudioRecording"; id: string }
      | { __typename: "Video"; id: string }
      | null;
  }>;
  session: {
    id: string;
    description?: string | null;
    hidden: boolean;
    prompt: string;
    publishedAt: string;
    media?: { __typename: "AudioRecording" } | { __typename: "Video" } | null;
    teacher: {
      id: string;
      name: string;
      profileImage?: { id: string; url: string } | null;
    };
  };
};

export type StudentNavMessageFragment = {
  id: string;
  content?: string | null;
  multipleChoiceOptionText?: string | null;
  stickers: Array<Types.Sticker>;
  createdAt: string;
  author:
    | {
        __typename: "Student";
        id: string;
        name: string;
        profileImage?: { id: string; url: string } | null;
      }
    | {
        __typename: "Teacher";
        id: string;
        name: string;
        profileImage?: { id: string; url: string } | null;
      };
  media?:
    | { __typename: "AudioRecording"; id: string }
    | { __typename: "Video"; id: string }
    | null;
};

export const StudentNavMessageFragmentDoc = gql`
  fragment StudentNavMessage on Message {
    id
    author {
      __typename
      id
      name
      profileImage {
        id
        url(format: small_profile)
      }
    }
    content
    multipleChoiceOptionText
    stickers
    createdAt
    media {
      __typename
      ... on AudioRecording {
        id
      }
      ... on Video {
        id
      }
    }
  }
`;
export const StudentNavReflectionFragmentDoc = gql`
  fragment StudentNavReflection on StudentSession {
    id
    hasNotifications
    hidden
    isExpired
    reportedByViewer
    studentReadAt
    messages {
      id
      ...StudentNavMessage
    }
    session {
      id
      description
      hidden
      prompt
      media {
        __typename
      }
      publishedAt
      teacher {
        id
        name
        profileImage {
          id
          url(format: small_profile)
        }
      }
    }
  }
  ${StudentNavMessageFragmentDoc}
`;
export const StudentNavigationDocument = gql`
  query StudentNavigation {
    studentViewer {
      id
      activeReflectionQuestions {
        nodes {
          id
          ...StudentNavReflection
        }
      }
      completedReflectionQuestions {
        nodes {
          id
          ...StudentNavReflection
        }
      }
      notifications {
        id
      }
      statsForStudent {
        allSessionsReceived
        allSessionsResponded
      }
    }
  }
  ${StudentNavReflectionFragmentDoc}
`;

/**
 * __useStudentNavigationQuery__
 *
 * To run a query within a React component, call `useStudentNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentNavigationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StudentNavigationQuery,
    StudentNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StudentNavigationQuery,
    StudentNavigationQueryVariables
  >(StudentNavigationDocument, options);
}
export function useStudentNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StudentNavigationQuery,
    StudentNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StudentNavigationQuery,
    StudentNavigationQueryVariables
  >(StudentNavigationDocument, options);
}
export function useStudentNavigationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StudentNavigationQuery,
    StudentNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StudentNavigationQuery,
    StudentNavigationQueryVariables
  >(StudentNavigationDocument, options);
}
export type StudentNavigationQueryHookResult = ReturnType<
  typeof useStudentNavigationQuery
>;
export type StudentNavigationLazyQueryHookResult = ReturnType<
  typeof useStudentNavigationLazyQuery
>;
export type StudentNavigationSuspenseQueryHookResult = ReturnType<
  typeof useStudentNavigationSuspenseQuery
>;
export type StudentNavigationQueryResult = Apollo.QueryResult<
  StudentNavigationQuery,
  StudentNavigationQueryVariables
>;
